const useBannerStyle = () => {
  const bannerBaseClass = (baseClass, variant) => {
    return `${baseClass} ${baseClass}--${variant}`;
  };

  const bannerIcon = (variant) => {
    switch (variant) {
      case 'success':
        return 'check_circle_outline';
      case 'info':
        return 'info_outline';
      case 'caution':
      case 'error':
        return 'error_outline';
    }
  };

  return { bannerBaseClass, bannerIcon };
};

export default useBannerStyle;
